export default __webpack_public_path__ + "static/media/icon.c1e52c6b.png";